module.exports = __webpack_public_path__ + "img/19_photo.6ece0046.png";